export default __webpack_public_path__ + "static/media/non_actif_trame_dark.6d0682ed.svg";